import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const UserProfileHook = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const postData = async (newData) => {
    try {
      const postData = {
        jsStruct: JSON.stringify(newData),
      };
      const response = await axios.post("/SchoolChangeContact", postData);
      setData((prevData) => [...prevData, response.data]);
      return response.data;
    } catch (error) {
      console.error("Error adding data:", error);
      throw error;
    }
  };

  return { data, loading, error, postData };
};

export default UserProfileHook;
